import styled from "styled-components";
import { LinkContent } from "./LinkDataInterface";
import { LinkButton } from "./LinkButton";

export const Table = styled.div`
  background: rgba(191, 79, 116, 0);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 5px;
  height: 100%;
  overflow: scroll;
`;

export function TableLink({ groups }: { groups: LinkContent[][] }) {
  return (
    <Table>
      {groups.map((group: LinkContent[]) => {
        return <GroupsLink group={group} />;
      })}
    </Table>
  );
}

const Group = styled.div`
  background-color: rgba(0, 32, 40, 0.5);
  border-radius: 10px;
  margin: 2%;
  padding: 10px 10px 0px 10px;
  width: auto;
`;

function GroupsLink({ group }: { group: LinkContent[] }) {
  return (
    <Group>
      {group.map((link) => {
        return <LinkButton item={link} />;
      })}
    </Group>
  );
}
